// employee/reducers.ts
const initialState = {
    getLandmarkData: [],
    getLandmarkCount: null,
    createLandmarkData: null,
    updateLandmarkData: null,
    getLandmarkMetaMessage: null,
    getLandmarkSuccess: false,
    getLandmarkFailure: false,
    createLandmarkSuccess: false,
    createLandmarkFailure: false,
    updateLandmarkSuccess: false,
    updateLandmarkFailure: false,
    deleteLandmarkSuccess: false,
    deleteLandmarkFailure: false,
};

export default function LandmarkReducer(state = initialState, action: any) {
    switch (action.type) {
        case 'GET_LANDMARK_SUCCESS': {
            return {
                ...state,
                getLandmarkSuccess: true,
                getLandmarkData: action.payload?.data?.data?.data,
                getLandmarkCount:action.payload?.data?.data?.meta?.total,
                getLandmarkFailure: false,
            };
        }
        case 'GET_LANDMARK_FAILURE': {
            return {
                ...state,
                getLandmarkFailure: true,
                getLandmarkMetaMessage: action.payload?.data?.data?.meta?.message,
                getLandmarkSuccess: false,
            };
        }
        case 'RESET_GET_LANDMARK': {
            return {
                ...state,
                getLandmarkSuccess: false,
                getLandmarkFailure: false,
                getLandmarkData: [],
                getLandmarkMetaMessage: null,
            };
        }

        case 'CREATE_LANDMARK_SUCCESS': {
            return {
                ...state,
                createLandmarkSuccess: true,
                createLandmarkData: action.payload?.data?.data?.data,
                getLandmarkMetaMessage: action.payload?.data?.data?.meta?.message,
                createLandmarkFailure: false,
            };
        }
        case 'CREATE_LANDMARK_FAILURE': {
            return {
                ...state,
                createLandmarkFailure: true,
                getLandmarkMetaMessage: action.payload?.data?.data?.meta?.message,
                createLandmarkSuccess: false,
            };
        }
        case 'RESET_CREATE_LANDMARK': {
            return {
                ...state,
                createLandmarkSuccess: false,
                createLandmarkFailure: false,
                createLandmarkData: null,
                getLandmarkMetaMessage: null,
            };
        }

        case 'UPDATE_LANDMARK_SUCCESS': {
            return {
                ...state,
                updateLandmarkSuccess: true,
                updateLandmarkData: action.payload?.data?.data?.data,
                getLandmarkMetaMessage: action.payload?.data?.data?.meta?.message,
                updateLandmarkFailure: false,
            };
        }
        case 'UPDATE_LANDMARK_FAILURE': {
            return {
                ...state,
                updateLandmarkFailure: true,
                getLandmarkMetaMessage: action.payload?.data?.data?.meta?.message,
                updateLandmarkSuccess: false,
            };
        }
        case 'RESET_UPDATE_LANDMARK': {
            return {
                ...state,
                updateLandmarkSuccess: false,
                updateLandmarkFailure: false,
                updateLandmarkData: null,
                getLandmarkMetaMessage: null,
            };
        }

        case 'DELETE_LANDMARK_SUCCESS': {
            return {
                ...state,
                deleteLandmarkSuccess: true,
                getLandmarkMetaMessage: action.payload?.data?.data?.meta?.message,
                deleteLandmarkFailure: false,
            };
        }
        case 'DELETE_LANDMARK_FAILURE': {
            return {
                ...state,
                deleteLandmarkFailure: true,
                getLandmarkMetaMessage: action.payload?.data?.data?.meta?.message,
                deleteLandmarkSuccess: false,
            };
        }
        case 'RESET_DELETE_LANDMARK': {
            return {
                ...state,
                deleteLandmarkSuccess: false,
                deleteLandmarkFailure: false,
                getLandmarkMetaMessage: null,
            };
        }

        default: {
            return state;
        }
    }
}
